$(document).ready(function () {
  // Recipes Poge
  var currentPathRecipes = window.location.pathname;

  // Check if the path matches "/blogs/recipes"
  if (currentPathRecipes === "/blogs/recipes") {
    // Recipes page empty p with role="status" changed to div
    if ($("#CartDrawer-LiveRegionText").length > 0) {
      const $element = $("#CartDrawer-LiveRegionText");
      const $div = $("<div>")
        .html($element.html())
        .attr("id", $element.attr("id"))
        .addClass($element.attr("class"));
      $element.replaceWith($div);
    }
  }
  // END OF - Recipes Poge

  // Product page
  var currentPathProduct = window.location.pathname;

  // Check if the path starts with "/products/"
  if (currentPathProduct.startsWith("/products/")) {
    // Product quantity - Live region

    $("[id*='Quantity-template']").after(
      '<div id="quantity-live-region" class="visually-hidden" aria-live="polite" aria-atomic="true"></div>'
    );

    function updateLiveRegion() {
      var $input = $("[id*='Quantity-template']");
      var currentValue = $input.val();
      var $liveRegion = $("#quantity-live-region");
      $liveRegion.text("Quantity " + currentValue);

      setTimeout(function () {
        $liveRegion.text("");
      }, 2000);
    }

    $('.quantity__button[name="minus"], .quantity__button[name="plus"]').on(
      "click",
      function () {
        setTimeout(updateLiveRegion, 50); // Delay to ensure the value has been updated
      }
    );

    $("[id*='Quantity-template']").on("input", function () {
      updateLiveRegion();
    });

    // Ref - Compliance Round March/2025
    // Adds a visually hidden text for the FUll Price crossed value
    function addHiddenText() {
      document.querySelectorAll('.fullPrice').forEach(el => {
        const alreadyAdded = el.querySelector('.visually-hidden');
        if (!alreadyAdded) {
          const hiddenText = document.createElement('span');
          hiddenText.className = 'visually-hidden';
          hiddenText.textContent = 'Full price';
          el.appendChild(hiddenText);
        }
      });
    }
    
    const targetLabel = document.querySelector('label[for="purchaseTypeSubscription"]');
    
    if (targetLabel) {
      const observer = new MutationObserver(() => {
        addHiddenText();
      });
    
      observer.observe(targetLabel, {
        childList: true,
        subtree: true
      });

      addHiddenText();
    }

    

    // Replaces the span with a label for the frequency combobox
    document.querySelectorAll('.rtx-subscription-box').forEach(box => {
      const span = box.querySelector('.frequency-heading');
      const select = box.querySelector('.rtx-subscription-dropdown');
    
      if (span && select) {
        if (!select.id) {
          select.id = 'rtx-select-' + Math.random().toString(36).substr(2, 9);
        }
        const label = document.createElement('label');
        label.textContent = span.textContent;
        label.setAttribute('for', select.id);
        label.className = 'frequency-label'; 
    
        span.replaceWith(label);
      }
    });
    

    // END OF - Ref - Compliance Round March/2025

  }
  // END OF - Product page

  // Cart Page
  var currentPathCart = window.location.pathname;

  // Check if the path matches "/cart"
  if (currentPathCart === "/cart") {
    // Cart Pages - Updates

    // Select the target node
    var targetNodeCartUpdates = document.querySelector(
      ".cart__items .js-contents"
    );
    // Options for the observer (which mutations to observe)
    var configCartUpdates = { childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    var callbackCartUpdates = function (mutationsList, observer) {
      for (var mutation of mutationsList) {
        if (mutation.type === "childList") {
          // Execute your code here
          handleCartUpdates();
        }
      }
    };
    // Create an observer instance linked to the callback function
    var observerCartUpdates = new MutationObserver(callbackCartUpdates);
    // Start observing the target node for configured mutations
    if (targetNodeCartUpdates) {
      observerCartUpdates.observe(targetNodeCartUpdates, configCartUpdates);
    }
    function handleCartUpdates() {
      // Your custom code to handle the cart updates
      // Wait 2 seconds before executing the tasks
      setTimeout(function () {
        var cartItemsCartUpdates = $(".cart__items");
        cartItemsCartUpdates.attr("tabindex", "-1");
        cartItemsCartUpdates.focus();
      }, 2000);
    }
    // END OF - Cart Pages - Updates
  }
  // END OF - Cart Page

  // Login Page
  var currentPathLogin = window.location.pathname;

  // Check if the path matches "/account/login"
  if (currentPathLogin === "/account/login") {
    setTimeout(function () {
      $("#customer_login")
        .contents()
        .filter(function () {
          return (
            this.nodeType === 3 &&
            this.nodeValue.trim() === "Incorrect email or password."
          );
        })
        .each(function () {
          if ($("#znt-23578562348-71238946").length === 0) {
            $(this).replaceWith(
              '<p id="znt-23578562348-71238946">Incorrect email or password.</p>'
            );
          } else {
            $(this).remove();
          }
        });
      $("#CustomerEmail, #CustomerPassword").attr(
        "aria-describedby",
        "znt-23578562348-71238946"
      );
    }, 500);
  }
  // END OF - Login Page


  // About Page
  var currentPath = window.location.pathname;

  // Check if the path matches "/pages/about-savannah-bee-company"
  if (currentPath === "/pages/about-savannah-bee-company") {
    // Check if the element with ID "Deferred-Poster-Modal-GutxK9zVoH8" exists on the page
    const elementToRemoveAriaLabel = $("[ID*='Deferred-Poster-Modal']");

    if (elementToRemoveAriaLabel.length) {
      // Remove the aria-label attribute from the element
      elementToRemoveAriaLabel.removeAttr("aria-label");
    }
  }
  // END OF - About Page

  // All Pages

  // Global maxlength fix
  $("[maxlength]").on("focus", function () {
    // Generate a unique ID for the live region based on the input's ID or other unique property
    var inputId = $(this).attr("id");
    var liveRegionId = inputId + "-live-region";

    // Check if the live region has already been added by looking for its specific ID
    if ($("#" + liveRegionId).length === 0) {
      // Add the aria-live span after this input with a unique ID
      $(this).after(
        '<span id="' +
          liveRegionId +
          '" class="live-region sr-only" aria-live="assertive"></span>'
      );
    }
  });

  $("[maxlength]").on("input", function () {
    var maxLength = parseInt($(this).attr("maxlength"));
    var currentLength = $(this).val().length;
    var inputId = $(this).attr("id");
    var liveRegion = $("#" + inputId + "-live-region");

    if (currentLength >= maxLength) {
      setTimeout(function () {
        // Set the text of the live region to announce it
        liveRegion.text(
          "The maximum of " + maxLength + " characters was reached."
        );

        // Clear the text after 2 seconds
        setTimeout(function () {
          liveRegion.text("");
        }, 2000);
      }, 3000);
    }
  });
  // END OF - Global maxlength fix

  // Cart Drawer tabindex removed
  setInterval(function () {
    $("#CartDrawer div.rebuy-product-grid").removeAttr("tabindex");
  }, 500);
  // END OF - Cart Drawer tabindex removed

  // Cart Drawer fix - Page reloads
  $(
    "<p class='znt-cart-drawer-info'>Changing the quantity will reload the page</p>"
  ).prependTo("cart-drawer-items");

  $(document).ready(function () {
    // Create a MutationObserver to observe changes to the class attribute
    var observerTab = new MutationObserver(function (mutationsTab) {
      mutationsTab.forEach(function (mutationTab) {
        if (
          mutationTab.type === "attributes" &&
          mutationTab.attributeName === "class"
        ) {
          var targetTab = $(mutationTab.target);
          var targetLink = targetTab.find("a");
          if (targetTab.hasClass("is-active")) {
            targetLink.attr("aria-selected", "true");
          } else {
            targetLink.attr("aria-selected", "false");
          }
        }
      });
    });

    // Configuration of the observer
    var configTab = { attributes: true, attributeFilter: ["class"] };

    // Function to initialize aria-selected attributes
    function initializeTabs(tabsContainer) {
      var tabs = $(tabsContainer).find(".tab");
      tabs.each(function (index) {
        var link = $(this).find("a");
        if (index === 0) {
          link.attr("aria-selected", "true");
          $(this).addClass("is-active");
        } else {
          link.attr("aria-selected", "false");
        }
      });

      // Observe each tab for changes in the class attribute
      tabs.each(function () {
        observerTab.observe(this, configTab);
      });
    }

    // Initialize each .tabs container
    $(".tabs").each(function () {
      initializeTabs(this);
    });
  });
  // END OF - Cart Drawer fix - Page reloads

  // Zenyth fix for 15% subscribe smsbump dialog
  // Function to add ARIA attributes to the modal
  function addAriaAttributes() {
    var modal = document.getElementById("SMSBump-Modal");
    if (modal) {
      document
        .querySelectorAll(".znt-carousel_toggle-pause")
        .forEach(function (element) {
          if (!element.classList.contains("clicked")) {
            element.classList.add("clicked");
            element.click();
          }
        });

      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("aria-label", "Discount Subscription");

      var closeButton = modal.querySelector("#SMSBump-Modal .close-button");
      if (closeButton) {
        setTimeout(function () {
          closeButton.focus();
        }, 10);
      }

      // Log when focus leaves the modal container and send focus to the close button
      modal.addEventListener("focusout", function (event) {
        if (!modal.contains(event.relatedTarget)) {
          if (closeButton) {
            setTimeout(function () {
              closeButton.focus();
              setTimeout(function () {
                var targetElement = document.querySelector(
                  '[id*="smsbump-form"] .mini-popup'
                );
                targetElement.focus();
              }, 1000);
            }, 10);
          }
        }
      });

      // Add keydown event listener to close modal on ESC key press
      modal.addEventListener(
        "keydown",
        function (event) {
          if (event.key === "Escape") {
            if (closeButton) {
              closeButton.click();
              var targetElement = document.querySelector(
                '[id*="smsbump-form"] .mini-popup'
              );
              if (targetElement) {
                setTimeout(function () {
                  targetElement.focus();
                  setTimeout(function () {
                    var targetElement = document.querySelector(
                      '[id*="smsbump-form"] .mini-popup'
                    );
                    targetElement.focus();
                  }, 1000);
                }, 50);
              }
            }
          }
        },
        true
      ); // Using 'true' to ensure the listener is in the capture phase
    }
  }

  // Set up a MutationObserver to detect when the modal is added to the DOM
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        addAriaAttributes();
      }
    });
  });

  // Configuration of the observer
  var config = { childList: true, subtree: true };

  // Start observing the document body
  observer.observe(document.body, config);

  // END OF - Zenyth fix for 15% subscribe smsbump dialog








  // END OF - All Pages
});
